import AuthorizedServicePoints from './components/AuthorizedServicePoints'

export default AuthorizedServicePoints
